import React from "react";
import "../App.css";

const SetupRequired: React.FC = () => {
  const projectId = "gam-project-lj1-bl5-upj";
  const functionsUrl = "https://us-central1-gam-project-lj1-bl5-upj.cloudfunctions.net";

  return (
    <div className="loading-container" style={{minHeight: "100vh", padding: "2rem"}}>
      <div className="card" style={{maxWidth: "800px", width: "100%"}}>
        <div className="card-header">
          <h1 className="card-title">⚙️ Setup Required</h1>
        </div>

        <div className="alert alert-info">
          <strong>Firebase configuration is missing.</strong> Please complete the setup steps below.
        </div>

        <div style={{marginTop: "2rem"}}>
          <h2 style={{marginBottom: "1rem", fontSize: "1.25rem"}}>
            Step 1: Enable Authentication
          </h2>
          <ol style={{lineHeight: "2", marginLeft: "1.5rem"}}>
            <li>
              Go to{" "}
              <a
                href={`https://console.firebase.google.com/project/${projectId}/authentication`}
                target="_blank"
                rel="noopener noreferrer"
                style={{color: "#3498db", textDecoration: "underline"}}
              >
                Firebase Authentication Console
              </a>
            </li>
            <li>Click "Get started" if you see that button</li>
            <li>Go to the "Sign-in method" tab</li>
            <li>Click on "Email/Password"</li>
            <li>Enable "Email/Password" and click "Save"</li>
          </ol>
        </div>

        <div style={{marginTop: "2rem"}}>
          <h2 style={{marginBottom: "1rem", fontSize: "1.25rem"}}>
            Step 2: Create Web App & Get Config
          </h2>
          <ol style={{lineHeight: "2", marginLeft: "1.5rem"}}>
            <li>
              Go to{" "}
              <a
                href={`https://console.firebase.google.com/project/${projectId}/settings/general`}
                target="_blank"
                rel="noopener noreferrer"
                style={{color: "#3498db", textDecoration: "underline"}}
              >
                Firebase Project Settings
              </a>
            </li>
            <li>Scroll to "Your apps" section</li>
            <li>Click the &quot;&lt;/&gt;&quot; (Web) icon to add a web app</li>
            <li>Register app with a nickname (e.g., "Compliance Portal")</li>
            <li>Copy the firebaseConfig object values</li>
          </ol>
        </div>

        <div style={{marginTop: "2rem"}}>
          <h2 style={{marginBottom: "1rem", fontSize: "1.25rem"}}>
            Step 3: Create .env File
          </h2>
          <p style={{marginBottom: "1rem"}}>
            Create a <code>.env</code> file in the project root with:
          </p>
          <pre
            style={{
              backgroundColor: "#f5f5f5",
              padding: "1rem",
              borderRadius: "6px",
              overflow: "auto",
              fontSize: "0.875rem",
            }}
          >
            {`REACT_APP_FIREBASE_API_KEY=your-api-key-here
REACT_APP_FIREBASE_AUTH_DOMAIN=${projectId}.firebaseapp.com
REACT_APP_FIREBASE_PROJECT_ID=${projectId}
REACT_APP_FIREBASE_STORAGE_BUCKET=${projectId}.appspot.com
REACT_APP_FIREBASE_MESSAGING_SENDER_ID=your-sender-id
REACT_APP_FIREBASE_APP_ID=your-app-id
REACT_APP_FUNCTIONS_URL=${functionsUrl}`}
          </pre>
        </div>

        <div style={{marginTop: "2rem"}}>
          <h2 style={{marginBottom: "1rem", fontSize: "1.25rem"}}>
            Step 4: Rebuild & Redeploy
          </h2>
          <p style={{marginBottom: "1rem"}}>
            After creating the <code>.env</code> file, run:
          </p>
          <pre
            style={{
              backgroundColor: "#f5f5f5",
              padding: "1rem",
              borderRadius: "6px",
              overflow: "auto",
              fontSize: "0.875rem",
            }}
          >
            {`npm run build
firebase deploy --only hosting`}
          </pre>
        </div>

        <div style={{marginTop: "2rem", paddingTop: "2rem", borderTop: "2px solid #e0e0e0"}}>
          <p style={{color: "#666", fontSize: "0.875rem"}}>
            <strong>Quick Links:</strong>
          </p>
          <div style={{marginTop: "0.5rem", display: "flex", flexDirection: "column", gap: "0.5rem"}}>
            <a
              href={`https://console.firebase.google.com/project/${projectId}/authentication`}
              target="_blank"
              rel="noopener noreferrer"
              style={{color: "#3498db"}}
            >
              🔐 Enable Authentication
            </a>
            <a
              href={`https://console.firebase.google.com/project/${projectId}/settings/general`}
              target="_blank"
              rel="noopener noreferrer"
              style={{color: "#3498db"}}
            >
              ⚙️ Project Settings (Get Config)
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetupRequired;

